import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Curso } from 'src/app/_models/curso';
import { Persona } from 'src/app/_models/persona';

@Component({
  selector: 'app-alumno-chip',
  standalone: false,
  templateUrl: './alumno-chip.component.html',
  styleUrls: ['./alumno-chip.component.scss']
})
export class AlumnoChipComponent implements OnInit, OnChanges {

  @Input() image: boolean;
  @Input() view: number;
  @Input() curso = false;
  @Input() asistencia = false;
  @Input() presencial = true;
  @Input() persona: any;
  @Input() acciones = [];
  @Input() asistencias: any[];
  @Input() cursoObj: Curso;
  @Output() accionEvento: EventEmitter<{persona: any, accion: any}>;

  accionesGlobales: any[];

  menuActivo: boolean;

  chips = [];

  constructor(private router: Router) {
    this.accionEvento = new EventEmitter();
  }

  ngOnInit(): void {
    this.accionesGlobales = [];
    this.menuActivo = this.accionesGlobales.length + this.acciones.length > 0;
    this.setChips();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.acciones && changes.acciones.firstChange === false) {
      this.menuActivo = this.accionesGlobales.length + this.acciones.length > 0;
    }
  }

  setChips() {
    if (this.presencial) {
      this.setChipPresencial();
    }
    if (this.curso) {
      this.setChipCurso(this.cursoObj);
    }
    if (this.asistencia) {
      this.setChipAsistencia(this.asistencias);
    }
  }

  setChipPresencial() {
    if (this.persona.autorizaciones) {
      if (this.persona.autorizaciones.find(item => item.tipoOrigen === 301)) { // AutorizacionPresencial
        this.chips.push({
          label: '@P',
          tooltip: 'Autorizacion presencial',
          styles: {background: '#ea5a0b', color: '#ffffff'}
        });
      }
    }
  }

  setChipCurso(curso: Curso) {
    this.chips.push({
      label: curso.nickName,
      tooltip: curso.nombre,
      styles: {background: '#ea5a0b', color: '#ffffff'}
    });
  }

  setChipAsistencia(asistencias: any[]) {
    asistencias.forEach(element => {
      this.chips.push({
        label: element,
        tooltip: element[0] === 'A' ? 'Asistencias' : 'Retardos',
        styles: element[0] === 'A' ? {background: '#ea5a0b', color: '#ffffff'} : {background: '#ea5a0b', color: '#ffffff'}
      });
    });
  }

  ejecutarAccion(accion) {
    if (accion.scope === 'global') {
      // TODO: Implementar
    } else {
      this.accionEvento.emit({persona: this.persona, accion});
    }
  }

}
